import React from 'react';
import { Box, Icon, Stack, TableCell } from 'investira.react.components';

/** Apresenta uma célula de tabela com a sinalização acessível de melhor valor. */
const MelhorValorTableCell = ({ children, isBest = false, sx, ...pProps }) => (
  <TableCell
    {...pProps}
    aria-label={isBest ? 'Melhor valor' : undefined}
    sx={{
      ...sx,
      ...(isBest
        ? {
            backgroundColor: 'background.dark',
            color: 'secondary.main',
            '& .MuiTypography-root': { color: 'warn.main', fontWeight: 500 }
          }
        : {})
    }}>
    {isBest ? (
      <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end">
        <Icon iconName="medal" size={14} color="warn" />
        <Box>{children}</Box>
      </Stack>
    ) : (
      children
    )}
  </TableCell>
);

export default MelhorValorTableCell;
